import { render, staticRenderFns } from "./GratificacionConfirmacionModal.vue?vue&type=template&id=2a1233c4&scoped=true"
import script from "./GratificacionConfirmacionModal.vue?vue&type=script&lang=js"
export * from "./GratificacionConfirmacionModal.vue?vue&type=script&lang=js"
import style0 from "./GratificacionConfirmacionModal.vue?vue&type=style&index=0&id=2a1233c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1233c4",
  null
  
)

export default component.exports